module.exports = __webpack_public_path__ + "img/54.689c208e.png";